import { IApplicationState } from '../../types/redux';

export const selectError = (state: IApplicationState): string | undefined => state.appStatus.error;
